/**
 * Rich options for the searchable selects that pick a master config or a
 * container: each in its own color — a master config as a crown tile with
 * its name over its campaign, a container as its color dot and name — so
 * the list reads at a glance like the board does.
 * For Media Devoted | Created By Ciro Autiero
 */
import { Crown } from 'lucide-react';
import type { SearchableSelectOption } from '@/components/ui';

import { middleTruncate } from '../campaign-scope';

interface MasterLike {
  id: string;
  name: string;
  color: string;
}

export function masterConfigOption(master: MasterLike, campaignName: string): SearchableSelectOption<string> {
  const campaign = middleTruncate(campaignName, 34);
  return {
    value: master.id,
    label: `${master.name} · ${campaignName}`,
    optionContent: (
      <span className="flex min-w-0 items-center gap-2.5" title={`${master.name} · ${campaignName}`}>
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md" style={{ backgroundColor: `${master.color}22` }}>
          <Crown className="h-3.5 w-3.5" style={{ color: master.color }} />
        </span>
        <span className="flex min-w-0 flex-col">
          <span className="truncate font-medium">{master.name}</span>
          <span className="truncate text-xs text-muted-foreground">{campaign}</span>
        </span>
      </span>
    ),
    triggerContent: (
      <span className="flex min-w-0 items-center gap-2">
        <Crown className="h-3.5 w-3.5 shrink-0" style={{ color: master.color }} />
        <span className="truncate font-medium">{master.name}</span>
        <span className="truncate text-xs text-muted-foreground">{campaign}</span>
      </span>
    ),
  };
}

export function containerOption(container: { id: string; name: string; color: string }): SearchableSelectOption<string> {
  const content = (
    <span className="flex min-w-0 items-center gap-2">
      <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: container.color }} />
      <span className="truncate font-medium">{container.name}</span>
    </span>
  );
  return { value: container.id, label: container.name, optionContent: content, triggerContent: content };
}
